import { Dayjs } from 'dayjs';

import 'dayjs/locale/ru';

export const getWeekDaysBetweenDates = (
  start: Dayjs,
  end: Dayjs,
): {
  date: Dayjs;
  dayOfWeek: number;
}[] => {
  const days: {
    date: Dayjs;
    dayOfWeek: number;
  }[] = [];
  let currentDate = start;

  while (currentDate.isBefore(end)) {
    const dayOfWeek = currentDate.day();
    days.push({
      date: currentDate,
      dayOfWeek: dayOfWeek === 0 ? 7 : dayOfWeek,
    });
    currentDate = currentDate.add(1, 'day');
  }

  return days;
};
